module.exports = __webpack_public_path__ + "static/2bc6207dc73792fe1ed7864fe256e40525f2ec4fe78ec1a8cf6743fcbe3f4b91-be8e4746e28dc73d0785999e34d539ea.png";